import { useQuery } from "@tanstack/react-query";
import { useStore } from "../../../helpers";
import {
  CANVAS_LIST_DEFAULT_LIMIT,
  CANVAS_LIST_DEFAULT_OFFSET,
  TARS_FACETS_LIST_PATH,
} from "../tars-constants";

export interface ListFacetsParams {
  notebook_id: number;
  source_id?: number;
  canvas_id?: number;
  offset?: number;
  limit?: number;
}

export interface ListFacetsResponse {
  facets?: Record<string, unknown>[];
  items?: Record<string, unknown>[];
  [key: string]: unknown;
}

export const useFacetList = (
  notebookId: number,
  sourceId: number,
  canvasId: number,
  enabled: boolean
) => {
  const rootStore = useStore();
  const offset = CANVAS_LIST_DEFAULT_OFFSET;
  const limit = CANVAS_LIST_DEFAULT_LIMIT;

  /** When no source is selected, omit source_id so the API scopes by canvas only. */
  const sourceKey = sourceId > 0 ? sourceId : "all";

  return useQuery({
    queryKey: ["tars", "facets", "list", notebookId, sourceKey, canvasId, offset, limit],
    enabled,
    queryFn: async () => {
      const body: ListFacetsParams = {
        notebook_id: notebookId,
        canvas_id: canvasId,
        offset,
        limit,
        ...(sourceId > 0 ? { source_id: sourceId } : {}),
      };
      const res = await rootStore.apiRequestHandler(
        TARS_FACETS_LIST_PATH,
        body,
        "Failed to list facets"
      );
      return (res.data ?? res) as ListFacetsResponse;
    },
  });
};
